import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../config';

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await fetch(`${API_URL}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });
            const data = await response.json();
            if (response.ok) {
                localStorage.setItem('accessToken', data.accessToken); // שמירת הטוקן
                navigate('/admin/contacts'); // העברה לעמוד הפניות
            } else {
                setError(data.error);
            }
        } catch (err) {
            setError('שגיאת רשת. לא ניתן להתחבר.');
        }
    };

    return (
        <div id="main">
            <section className="post">
                <header className="major" style={{textAlign: 'center'}}>
                    <h1>כניסה למערכת ניהול</h1>
                </header>
                <form onSubmit={handleSubmit}>
                    <div className="fields">
                        <div className="field"><input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="שם משתמש" /></div>
                        <div className="field"><input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="סיסמה" /></div>
                    </div>
                    <ul className="actions">
                        <li><input type="submit" value="התחבר" className="primary" /></li>
                    </ul>
                    {error && <p style={{color: 'red'}}>{error}</p>}
                </form>
            </section>
        </div>
    );
}
export default LoginPage;